module.exports = __webpack_public_path__ + "img/sample24.ffa63746.jpg";